<template>
    <v-card class="hoverCard" fill-height :style="'height:100px;margin:5px;background-color:'+color+';'" v-on:click="select(currentFault)" v-on:mouseleave="mouseLeave" v-on:mouseover="color='rgb(219,219,219)'">
        <v-container fluid grid-list-md style="padding:5px;height:100%;">
            <v-layout row fill-height>
                <v-flex d-flex xs9 sm10>
                    <v-layout column>
                        <v-flex d-flex md3 style="align-items:center;">
                            <img style="max-height:25px;max-width:25px;" :src="img" alt="">
                            <div style="display:flex;align-items:center;margin-left:5px;font-size:14px;"> {{ currentFault.fault }}</div>
                        </v-flex>
                        <v-flex d-flex md4>
                            <v-layout row>
                                <v-flex d-flex xs5 md4 :class="'line-start parameter-value'">{{currentFault.events.length}}</v-flex>
                                <v-flex d-flex xs7 md8 :class="'parameter-value'">{{ currentFault.startDate | dateFormatter }}</v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex d-flex md2>
                            <v-layout row>
                                <v-flex d-flex xs5 md4 :class="'parameter-title line-start'">
                                    <v-layout row wrap>
                                        <v-flex d-flex sm4 :class="'twin-title-top'">Occurrences</v-flex>
                                        <v-flex d-flex sm4 :class="'twin-title-bottom'">(Minutes)</v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex d-flex xs7 md8 :class="'parameter-title'" style="">First appeared</v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex d-flex xs3 sm2>
                    <v-layout column>
                        <v-flex d-flex md4 :class="'parameter-value'">{{ currentFault.element }} {{ currentFault.index }}</v-flex>
                        <v-flex d-flex md2 :class="'parameter-title'" style="">Element</v-flex>
                        <v-flex d-flex md4 :class="'parameter-value'">{{ currentFault.component }}</v-flex>
                        <v-flex d-flex md2 :class="'parameter-title'" style="">Subsystem</v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-container>
    </v-card>
</template>

<script>
    export default {
        name: "FaultCard",
        components: {},
        props: {
            currentFault: Object,
            kpi: Object,
            selFaultId: Number
        },
        data() {
            return {
                red: require('../assets/colordotsred.png'),
                orange: require('../assets/colordotsorange.png'),
                color: 'rgb(255,255,255)'
            }
        },
        mounted() {
            if (this.selFaultId == this.currentFault.Id) this.color = 'rgb(219,219,219)';
            else this.color = 'rgb(255,255,255)';

        },
        computed: {
            img: function () {
                if (this.currentFault.color == 20) return this.red;
                else return this.orange;
            },
        },
        filters: {
            dateFormatter: function (value) {
                if (!value) return '';
                let d = new Date(value);
                return d.toLocaleString();
            }
        },
        methods: {
            select: function (fault) {
                this.$emit('faultChange', fault.Id);
            },
            mouseLeave: function () {
                if (this.selFaultId == this.currentFault.Id) this.color = 'rgb(219,219,219)';
                else this.color = 'rgb(255,255,255)';
            }
        },
        watch: {
            selFaultId() {
                if (this.selFaultId == this.currentFault.Id) this.color = 'rgb(219,219,219)';
                else this.color = 'rgb(255,255,255)';
            }
        }
    }
</script>

<style scoped>
    .hoverCard:hover {
        background-color: rgb(219, 219, 219);
    }

    .line-start {
        margin-left:30px;
    }

    .parameter-value {
        font-size:15px;
        align-items:flex-end;
        line-height: 14px !important;

        position: relative;
        top: 8px;
    }

    .parameter-title {
        color:rgb(115,115,115);
    }

    .twin-title-top {
        padding-bottom: 0 !important;
    }

    .twin-title-bottom {
        padding-top: 0 !important;
        font-size: 10px;
        line-height: 10px !important;
    }

    @media screen and (orientation:landscape) {
        .twin-title-bottom {
            line-height: 30px !important;
        }

        .parameter-value {
            line-height: 16px;
        }
    }
</style>
